module.exports = __webpack_public_path__ + "static/img/b0-out@2x.36735e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/change-icon/b0-out@2x.png
// module id = KZss
// module chunks = 0